import { CampaignStatus } from "~frontend/__generated__/graphql";
import { CampaignWithSuppressionData } from "~frontend/routes/types";

export function isSendInProgress(
  campaign: CampaignWithSuppressionData
): boolean {
  return (
    campaign.status === CampaignStatus.InitialSendRunning ||
    campaign.status === CampaignStatus.InitialSendCanceling
  );
}
